import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

// own module
import { JssTreeNodeType } from './jss-types';

export const enum JssAbstFlags {
   NULL =                  0,      // for initialization
   TITLE_DEFINED =         1 << 1, // 2
   REQUIRED_DEFINED =      1 << 2, // 4
   SHOW_TITLE =            1 << 3, // 8

   // initialization
   INIT_VALUE = SHOW_TITLE
}

export abstract class JssNodeAbstract {

   protected _parent: JssNodeAbstract = null;
   protected _children: JssNodeAbstract[] = [];
   protected _title = '';
   protected _abstFlags: JssAbstFlags = JssAbstFlags.INIT_VALUE;
   protected _lytOrder = 0;

   constructor(
      protected _nodeName: string,
      protected _nodeType: JssTreeNodeType
   ) {

   }

   // basic function to manage tree
   public get nodeName(): string {return this._nodeName; }
   public get nodeType(): string {return this._nodeType; }
   public get children(): JssNodeAbstract[] {return this._children; }
   public set parent(parent: JssNodeAbstract) {this._parent = parent; }

   // layout
   public set lytOrder(order: number) {this._lytOrder = order; }
   public get lytOrder(): number {return this._lytOrder; }

   public getAbstFlags(): JssAbstFlags {
      return this._abstFlags;
   }

   // title
   public set title(title: string) {
      this._title = title;
      this._abstFlags = FlagsHelper.setFlag(this._abstFlags, JssAbstFlags.TITLE_DEFINED, true);
   }
   public get title(): string {return this._title; }
   public hasTitle(): boolean {
      return FlagsHelper.isFlagSet(this._abstFlags, JssAbstFlags.TITLE_DEFINED);
   }
   public set showTitle(show: boolean) {
      this._abstFlags = FlagsHelper.setFlag(this._abstFlags, JssAbstFlags.SHOW_TITLE, show);
   }
   public get showTitle(): boolean {
      return FlagsHelper.isFlagSet(this._abstFlags, JssAbstFlags.SHOW_TITLE);
   }

   public get enabled(): boolean {
      return true;
   }

   // required
   public set required(value: boolean) {
      this._abstFlags = FlagsHelper.setFlag(
         this._abstFlags, JssAbstFlags.REQUIRED_DEFINED, true);
   }
   public isRequired(): boolean {
      return FlagsHelper.isFlagSet(this._abstFlags, JssAbstFlags.REQUIRED_DEFINED);
   }

   public getExclusiveChild(): JssNodeAbstract {
      if (!this._children || this._children.length !== 1) {
         console.warn('Request for one children, but its not unique');
         return null;
      }
      return this.children[0];
   }

   // recursive (recve) functions
   public abstract recveDumpJssTree(indent: string);
   public abstract recveEvalSchema(dump_output: boolean);
   public abstract recveGenFormTree(form: FormGroup);
   public abstract recveCreateDataObject(data: any);
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/jss-tree-abstract.ts